import pub from './../public';
const type = pub.getLang();
const language = {
  'zh-hk': {
    remark: '放盤列表排序說明',
    PropertyValuation: '銀行估價',
    PropertyValuationTips: '開啟後，用戶可在樓盤詳情頁中使用銀行估價功能(如有)即時物業估值服務由中國銀行(香港)有限公司委托第三方提供，僅供參考。',
    consultingText1: '如有放盤問題，歡迎致電 3619 3200 查詢',
    consultingText2: '星期一至五，上午9時到下午6時',
    unitFloorTips: '根據總樓層數量除以3，分為高/中/低層',
    addressTips: '所輸入的內容，將會在樓盤詳情頁顯示，請不要輸入完整地址',
    noRenewalText: '因樓盤資料不完整，無法續期樓盤，須先補回填寫資料',
    parNowText: '因樓盤資料不完整，無法付款，須先補回填寫資料',
    propertyInformation1: '樓盤資料絕對保密，樓層會以高/中/低層顯示，用於快將推出的估價功能(如有)',
    propertyInformation2: '樓盤資料顯示: 你的樓盤資料將會以此顯示在House730',
    propertyInformation3: '樓盤資料絕對保密，樓層會以高/中/低層顯示',
    PropertySelected: '請選擇樓盤類型',
    selectText: '選擇',
    estateAddress: '街道號碼',
    estateAddressPlaceHolder: '如:天湖路1號',
    estateYear: '樓齡(年)',
    cancelEditTxt: '如果你在頁面上有進行過修改，離開當前頁面會導致所做的修改將丟失',
    cancelEdit: '取消更改',
    yes: '是',
    no: '否',
    propertyVerificationtxt1: '樓盤驗證失效提示',
    propertyVerificationtxt2: '因為你修改過以下任何一個資料，樓盤驗證會失效，我們需要重新審核',
    propertyVerificationtxt3: '請問需要重新提交樓盤驗證嗎？',
    submitHouseInfo: '是否需確認提交資料？',
    creditCard:'信用卡',
    cre: '信用卡 (VISA, Mastercard)',
    tipsKeyWord: '服務式住宅租期至少在一個月以上，一年之內；由業主提供裝修，廚房，傢俬在內的全套家居設備，以及維修與服務在內的中央管理。',
    tipsKeyWord_GongJv: '共居租期通常至少一個月以上。業主負責提供裝修完善的住宅空間，包括必要的家具和共享的公共區域，如廚房、客廳和浴室等。每位租戶擁有自己的私人臥室，同時需要共用公共區域。​',
    //平面图
    FreeY: '免費',
    choosepropertyPlat: '平面圖',
    propertyPlat: '選擇平面圖',
    chooseImg: '已添加',
    zhang: '張',
    setArea: '自訂面積',
    unit: '單位：平方呎',
    smallestArea: '最小實用面積',
    largestArea: '最大實用面積',
    errorSaleableArea: '實用面積區間錯誤',
    phase: '期數',
    block: '座數',
    floor: '樓層',
    unitD: '單位',
    saleableArea: '實用面積',
    eachType: '每款平面圖只可選擇一張',
    unitFloorPlan: '單位平面圖',
    floorPlan: '樓層平面圖',
    highestSFA: '最大實用面積',
    lowestSFA: '最小實用面積',
    house730: '@House730提供',
    selectedFloorplan: '已選平面圖',
    sorry: '暫時未有提供相關平面圖，我們正努力製作中',


    imgloading: '上傳中',
    Inline: '列隊中',
    imgfaile: '上傳失敗',
    imgdel: '請刪除',
    //commonwords
    popover: '最多選擇五項',
    selectWords: '選擇常用詞',
    usualWords: '請選擇常用詞',
    maxSentence: '請最多選擇5句，再自行修改',
    maxInSentence: '請最多選擇10句，再自行修改',


    setNow: '立即設定',
    setEmailNotice: '刊登樓盤前，必須設定電郵',
    setWordNotice: '刊登樓盤前，必須設定密碼',
    keyWords: '內容不符合會員條款',
    keyCon: '確認',
    cant: '無法刊登',
    // post
    stop: '對不起，功能暫時停用',
    start: '請前往會員中心上傳您的地產代理證，待確認後功能會重新啟用',
    goEdit: '前往會員中心',
    // upscan
    postSuccess: '樓盤已成功刊登，妳現在可以關閉此頁面',
    centSign: '中原樓市片區',
    // up_pic
    first: '封面',
    maximumPhotos1: '已選擇',
    maximumPhotos2: '張圖片 最多可上傳20張圖片 ',
    maximumPhotos3: '移動圖片可調換圖片位置，左上角第一張為封面圖',
    delPic: '移除圖片',
    picLength: '已超過圖片上傳數量限制',
    picuping: '圖片上傳中',
    picfailure: '上傳失敗,請重新上傳',
    fileBig: '檔案大小必須20MB以下',
    fileError: '只支持png、jpg、jpeg格式的圖片',
    fileExist: '存在重複文件，已過濾',
    // 标题
    toptitle: '刊登樓盤',
    vid_title: "樓盤影片",
    vid_cover: "影片封面",
    up_title: '上傳圖片',
    up_vid: '請輸入影片連結',
    up_yfvid: "請輸入YouTube或Facebook網站的影片連結",
    paytitle: '立即付款',
    edittitle: '更改樓盤資料',
    copytitle: '複製樓盤',
    addSuntitle: '續期',
    topclear: '清空',
    prev: '上一步',
    next: '下一步',

    // 楼盘标签
    tag: '標籤',
    alsel: "已選",
    ected: '個標籤',
    order: '調整標籤順序',
    char: '單位特色',
    mofour: '最多選擇4個',
    sce: '景觀',
    ren: '裝修',
    moone: '最多選擇1個',
    mat: '配套',
    mothree: '最多選擇3個',
    mosix: '最多選擇6個',
    notice: '註：步行往港鐵站約',
    sub: '分鐘',
    foottime: '步行時間是由系統計算出來的，當步行時間在15分鐘內，可選擇＂近港鐵＂標籤',
    bus: '工商專用',
    park:'配套(車位專用) ',
    alselected: '已選標籤:',
    showfive: '樓盤列表只會顯示前5個標籤',
    drag: '按住可拖動標籤調整順序，列表與詳情頁根據順序顯示',


    // step1
    nopic: '沒有選擇圖片',
    continue: '確定要繼續?',
    confrimExit: '確定退出?',
    goaway: '你所輸入的樓盤內容將不會被儲存',
    confirm: '確定',
    confirm1: '確認',
    soonPost: '立即刊登',
    yezhuTit: '業主免費放盤',
    yezhuCon: 'House730現免費供業主刊登樓盤，業主只需填妥刊登放盤資料並上傳地址證明，就可以免費放盤!',
    yezhuAdd:'放盤後, House730會先作出審批再作上架。',
    cancel: '取消',
    Clearcontent: '確定清除已輸入內容？',
    clear: '清除',
    addPic: '樓盤圖片',
    addVid: '樓盤視頻',
    addTips: '加入圖片可令你的樓盤更吸引',
    write: '請填寫',
    selsctSource: '選擇盤源',
    agent: '盤源',
    contactNameChi: '聯絡人名稱',
    contactNameEng: '聯絡人英文名稱',
    landlord: '業主',
    titOne: '樓盤及聯絡資料',
    source: '盤源',
    email: '電郵地址',
    tel: '聯絡電話',
    telShow: '顯示電話',
    showPhone: '顯示電話號碼',
    dontShow: '不顯示我的電話',
    alipayText: '只適用於已註冊的Alipay HK用戶',
    wePayText: '只適用於已註冊的WeChat Pay HK用戶',
    isHideCompanyInfo: {
      dictionaryNameWithCulture: '代理公司資料及個人地產代理牌照',
      dictionaryContent: '如揀選不顯示，在樓盤詳情中，只會顯示代理聯絡電話和代理牌照，不會顯示公司名稱、地址、公司電話，公司牌照',
      itemName: "isHideCompanyInfo",
      children: [{
        dictionaryNameWithCulture: '顯示',
        dictionaryValue: false,
        id: 0,
      }, {
        dictionaryNameWithCulture: '不顯示',
        dictionaryValue: true,
        id: 0,
      }]
    },
    isShowTel: {
      dictionaryNameWithCulture: '顯示電話',
      itemName: "isShowTel",
      children: [
        {
          dictionaryNameWithCulture: '顯示電話',
          dictionaryValue: true,
          children: [
            {
              dictionaryNameWithCulture: '我有WhatsApp',
              dictionaryValue: 1,
              id: 0,
              attr: 'isShowWhatsApp'
            }
            // {
            //   dictionaryNameWithCulture: '我有WeChat',
            //   dictionaryValue: 2,
            //   id: 1,
            //   attr: 'isShowWeChat'
            // }
          ]
        }, {
          dictionaryNameWithCulture: '不顯示我的電話',
          dictionaryValue: false
        }
      ]
    },
    // children
    // tool: ['我有WhatsApp', '我有WeChat'],


    // step2
    agencyInformation: '地產代理資料',
    companyName: '代理公司名稱',
    companyShow: '代理公司資料及個人地產代理牌照',
    companyNameEng: '代理公司名稱英文',
    companyPhone: '代理公司電話',
    chinaMobile: '國內聯絡電話',
    companyAddress: '代理公司地址',
    companyLicense: '公司地產代理牌照',
    personalLicense: '個人地產代理牌照',
    agentCard: '地產代理證',
    // agentCardTime: '地產代理證到期日',
    agentCardTime: '地產牌照屆滿日期',
    not86: '(無須填寫86)',
    show: '顯示',
    notShow: '不顯示',
    upload: '上傳',
    // step3
    propertyTypeAndAddress: '放盤分類及地址',
    housenum: '期數',
    housenum1: '期數',
    buildNum: '座數',
    propertyType: '樓盤類型',
    propertyTags: '樓盤標籤',
    onlyCategories: '最多選擇兩個分類',
    towerAndUnit: '座數及單位',
    propertyAddress: '物業地址',
    // searchBuilding
    estateOrBuildingName: '屋苑或大廈名稱',
    manuallyEnterBuilding: '如你找不到屋苑名或大廈名稱，你亦可手動輸入屋苑名稱。',
    inputEstateOrBuildingName: '手動輸入地區屋苑',
    region: '地區',
    district: '樓市片區',
    houseChiName: '屋苑或大廈名稱(中文）',
    houseEngName: '屋苑或大廈名稱(英文）',
    search: '搜尋：屋苑或大廈名稱',
    checked: '手動輸入的屋苑或大廈,將由House730管理員審核',
    requireAddress: {
      region: '請選擇屋苑所在地區',
      houseChiName: '請輸入屋苑或大廈名稱'
    },
    // step4
    rentTime: '可隨時起租',
    SaleFrom: '綠/白表',
    areaPoint: '實用面積或建築面積至少填寫一項',
    MsaleForm:'未補或已補地價至少填寫一項',
    propertyprice: '樓盤價格及面積',
    sale: '放售',
    rent: '放租',
    sellPrice: '放售價',
    sellPriceUnit: '萬元',
    rentalPrice: '放租價',
    renPriceUnit: '元',
    startDate: '起租日',
    revRatio:'選擇後會在House730顯示減價比率，最大比率為30%',
    evaVau:'減價盤',
    areaUncheck:'面積未核實',
    mesUncheck:'如面積未核實，須註明並會在',
    houseWebsite:'House730網頁上顯示。',
    remove: '移除',
    withCarParkL: '連車位',
    buildArea: '建築面積(呎）',
    useArea: '實用面積(呎）',
    reviewArea: '面積資料未審核',
    mrentPrice: '每月租金(元）',
    unPaid:'未補地價',
    alPaid:'已補地價',
    yibu:'已補',
    weibu:'未補',
    mrebtData: '起租日',
    otherOps: ' 其他選項',
    rentOrSale: '只可選放售或放租其中一項',
    // step5
    bedrooms: '房間數目',
    propertyInfo: '樓盤資料',
    propertyNumber: '物業編號',
    eaaRequired: 'EAA 要求提供',
    adsTitleChi: '放盤標題(中文)',
    adsTitleEng: '放盤標題(英文)',
    titleLimitC: '最多30字',
    titleLimitE: '最多50字',
    propertyDescription: '樓盤介紹',
    propertyDescriptionChi: '樓盤介紹(中文)',
    propertyDescriptionEng: '樓盤介紹(英文)',
    descriptionLimitC: '最多300字',
    descriptionLimitE: '最多600字',
    propertyDetails: '樓盤詳情',
    height: '高/中/低層',
    height1: '樓層',
    noOfRooms: '房間數目',
    ToiletRooms: '洗手間數目',
    age: '屋苑樓齡(年)',
    monthlyManagementFee: '每月管理費(元)',
    // step6
    topOne: '刊登精選盤必須上載至少一張圖片',
    maxRenewal: '已達續期上限\n在有效期內樓盤最多續期1次',
    tip: '提示',
    tipStatus: '訂單狀態不正確，請重試!',
    ri: '日',
    agreeClause: '必須同意放盤條款才可繼續',
    paywayRequ: '付款方式及放盤方式為必選',
    addRequ: '請提交樓盤驗證文件',
    yezhuRequ: '請上傳免費放盤驗證文件',
    noChance: '操作失敗',
    GoldCoin: '金幣',
    // Dpayway: [{ name: 'PayPal', value: '1' }, { name: 'House730金幣', value: '2' }, { name: '銀行轉帳', value: '3' }],
    // NoCoinPayway: [{ name: 'PayPal', value: '1' }, { name: '銀行轉帳', value: '3' }],
    span: '售盤為期',
    zpan: '租盤為期',
    szpan: '售盤/租盤為期',
    adClass: '放盤方式',
    Generallisting1: '一般放盤',
    Generallisting2: '有較高曝光機會',
    updateSuccess: '樓盤資料已更新',
    payway: '付款方式',
    listingNorl: '標準盤',
    listingGolt: '精選盤',
    listingStar: "星級盤",
    Conditions: ['同意', '放盤條款'],
    verif: '樓盤驗證',
    verifRemark: '樓盤詳情顯示為<span style="color:#ED1818">「已驗證」</span>,加強買家/租戶信心',
    addressProof: '樓盤驗證文件',
    upYezhufile: '上傳免費放盤驗證文件',
    imgTit:'(只接受JPEG, JPG及PNG圖片格式)',
    submit: '提交放盤',
    needMoeny: '金額',
    subEdit: '提交更改',
    confrimType: '確定放盤類型',
    confrimCate: '放盤方式',
    confrimMoeny: '付款總額',
    confrimtxt: '請按確定提交放盤及付款',
    previous: '上一步',
    RenewalFee: '升級或續期',
    thanks: '付款成功',
    submitSuc:'提交成功',
    payDone: '你的樓盤已刊登',
    payDownStar: '星級盤參考排名將於稍後更新',
    payAdd: '你的升級或續期已成功付款',
    noGold: '金幣不足', //屋币不足提示
    noGoldText: '請先增值或改用其他方式付款',
    addGold: '增值',
    // address
    addTit: '地址證明',
    addYezhu: '上傳免費放盤驗證文件',
    up: '最多只能上传3張傳圖片',
    uptitle: '上傳圖片(最多3張）',
    address1: '請上傳樓盤的委託放盤證明、確實地址、業權證明及其他相關資料，或將相關資料WhatsApp到 5726 6308，我們會在3個工作天內完成審核',
    address2: '如果你是業主，請提供電費單/水費單/差餉',
    address3: '如果你是代理，請提供委託放盤證明及其他相關資料',
    address4: '如審核過程發現證明文件與樓盤資料不符，樓盤將被下架並不作另行通知。',
    address5: '請提供附有樓盤確實地址的證明，建議上傳以下其中一類型文件，包括：',
    address6: '- 電費單',
    address7: '- 水費單',
    address8: '- 差餉',
    address9: ' - 管理費單',
    address10: '- 車位圖片 *只適用於刊登車位',
    address11: '你的樓盤將由House730審批上架。',
    address12: '一般在1-3個工作天內完成，我們會發電郵通知你。',
    address13: '如審核過程發現證明文件與樓盤資料不符，樓盤將不會被上架。',
    address14: '如有任何問題，歡迎與我們聯絡 WhatsApp：+852 5726 6308/ Email：general@house730.com(標題請註明“樓盤審核”)/Tel：+852 3619 3200',
    // 楼盘校验
    require: {
      phase: '請選擇期數',
      buildName: '請選擇座數',
      subcgory:'請選擇樓盤詳細類別',
      buildFloorRequire: '請選擇樓層',
      unitFloorRqueire: '星級盤必須選擇高/中/低層',
      toiletNumberRqueire: '星級盤必須選擇洗手間數目',
      unitFloorRqueire1: '請選擇高/中/低層',
      plamtImage: '請選擇平面圖',
      areaTip: '實用面積必須細過或等於建築面積',
      source: '請選擇盤源',
      Cname: '請輸入聯絡人名稱',
      email: '請輸入電郵地址',
      emailFormat: '電郵地址錯誤',
      tel: '請輸入聯絡電話',
      telFormat: '格式錯誤 - 聯絡電話',
      telShow: '請選擇是否顯示電話',
      companyName: '請填寫代理公司名稱',
      companyShow: '請選擇是否顯示代理公司資料及個人地產代理牌照',
      companyPhone: '請填寫代理公司電話',
      companyLicense: '請填寫公司地產代理牌照',
      personalLicense: '請填寫個人代理牌照',
      companyTelFormat: '格式錯誤 - 代理公司電話',
      TelFormat: '格式錯誤 - 國內聯絡電話',
      agentCardPath: '請上傳地產代理證',
      // agentCardExpireTime:'請選擇地產代理證到期日',
      agentCardExpireTime:'請選擇地產牌照屆滿日期',
      // 楼盘信息
      propertyType: '請選擇樓盤類型',
      estateOrBuildingName: '請輸入屋苑或大廈名稱',
      rent: '請填寫每月租金',
      Area: '請填寫建築面積或實用面積',
      MsaleForm:'未補或已補地價至少填寫一項',
      sale: '請輸入放售價',
      SaleForm: '請選擇綠表價或白表價',
      salePrice: '格式錯誤 - 放售價',
      rentPrice: '格式錯誤 - 每月租金',
      buildArea: '格式錯誤 - 建築面積',
      saleArea: '格式錯誤 - 實用面積',
      adsTitleChi: '請填寫放盤標題(中文)',
      adspropertyNumber: '請輸入物業編號',
      propertyDescriptionChi: '請填寫樓盤介紹(中文)',
      age: '格式錯誤 - 屋苑樓齡',
      monthlyManagementFee: '格式錯誤 - 每月管理費',
      adspropertyNumErr: '物業編號必須為英文字母、數字或符號',
      starHeight: '星級盤必須選擇單位樓層',
      startRequir: '星級盤必須選擇',
      starRoom: '星級盤必須選擇房間數目',
      starTitCn: '星級盤中文標題必須不少於8個字',
      starImage: `星級盤必須上載3張圖片`,
      nomalImage: `刊登標準盤必須上載至少一張圖片`
    },
    imageTips: `標準盤 - 上載至少1張圖片、星級盤 - 上載至少3張圖片`,
    saleTitle: '售盤',
    rentTitle: "租盤",
    chooseType: '請選擇放盤方式',
    startTip: '星級盤必須選擇單位樓層、房間數目和洗手間數目',
    quitChoose: '取消選擇',
    propertyDetail: "放盤資料",
    concantDetail: '聯絡資料',
    Coin: 'House730金幣',
    transferFake: '(會在下一個工作天內處理完成)',
    transfer: '銀行轉帳',
    visa: '適用於信用卡, Visa/MasterCard結賬',
    clearAll: '取消所有選項',
    pleSelect: '請選擇',
    pleInput: '請輸入',
    saleO:'目前售價為',
    saleOt:'億元,',
    saleOth:'確定',
    saleOf:'更改',
    saleOfi:'萬元,',
    saleOs:'請確定或更改你的售價',
    saleOse:'你所輸入的售價與原本的有很大的差距',
    saleOe:'請確認售價是否正確',
    saleOn:'知道了',
    propertyNoPleSelect: 'EAA要求提供請輸入',
    photoPosition: '圖片位置',
    moveDel: '拖動到此處移除',
    photoIntro: '第一張為封面，移動圖片可調換圖片位置',
    photoIntro2: '點擊圖片可進行預覽，加入圖片位置及描述',
    notSave: '你尚未儲存',
    saveTip: '若確認捨棄，系統將不會儲存圖片位置及描述',
    photoMax: '請輸入圖片描述（最多50個字）',
    chucun: '儲存',
    diqu: '地區選擇'
  },
  'zh-cn': {
    remark: '放盘列表排序说明',
    PropertyValuation: '银行估价',
    PropertyValuationTips: '开启后，用户可在楼盘详情页中使用银行估价功能(如有)即时物业估值服务由中国银行(香港)有限公司委托第三方提供，仅供参考。',
    unitFloorTips: '根据总楼层数量除以3，分为高/中/底层',
    consultingText1: '如有放盘问题，欢迎致电 3619 3200 查询',
    consultingText2: '星期一至五，上午9时到下午6时',
    addressTips: '所输入的内容，将会在楼盘详情页显示，请不要输入完整地址',
    noRenewalText: '因楼盘资料不完整，无法续期楼盘，须先补回填写资料',
    parNowText: '因楼盘资料不完整，无法付款，须先补回填写资料',
    propertyInformation2: '楼盘资料显示：你的楼盘资料将会以此显示在House730',
    propertyInformation3: '楼盘资料绝对保密，楼层会以高/中/低层展示',
    PropertySelected: '请选择楼盘类型',
    selectText: '選擇',
    estateAddress: '街道号码',
    estateAddressPlaceHolder: '如:天湖路1号',
    estateYear: '楼龄(年)',
    cancelEditTxt: '如果你在页面上有进行过修改，离开当前页面会导致所做的修改将丢失',
    cancelEdit: '取消更改',
    yes: '是',
    no: '否',
    submitHouseInfo: '是否确认提交资料',
    propertyVerificationtxt1: '楼盘验证失效提示',
    propertyVerificationtxt2: '因为你修改过以下任何一个资料，楼盘验证会失效，我们需要重新审核',
    propertyVerificationtxt3: '请问需要重新提交楼盘验证吗？',
    creditCard:'信用卡',
    cre: '信用卡 (VISA, Mastercard)',
    tipsKeyWord: '服务式住宅租期至少在一个月以上，一年之内；由业主提供装修，厨房，家私在内的全套家居设备，以及维修与服务在内的中央管理。',
    tipsKeyWord_GongJv: '共居租期通常至少一个月以上。业主负责提供装修完善的住宅空间，包括必要的家具和共享的公共区域，如厨房、客厅和浴室等。每位租户拥有自己的私人卧室，同时需要共用公共区域。​',
    FreeY: '免费',
    // 平面圖
    choosepropertyPlat: '平面图',
    propertyPlat: '选择平面图',
    chooseImg: '已添加',
    zhang: '张',
    setArea: '自订面积',
    unit: '单位：平方尺',
    smallestArea: '最小实用面积',
    largestArea: '最大实用面积',
    errorSaleableArea: '实用面积区间错误',
    phase: '期数',
    block: '座数',
    floor: '楼层',
    unitD: '单位',
    saleableArea: '实用面积',
    eachType: '每款平面图只可选择一张',
    unitFloorPlan: '单位平面图',
    floorPlan: '楼层平面图',
    highestSFA: '最大实用面积',
    lowestSFA: '最小实用面积',
    house730: '@House730提供',
    selectedFloorplan: '已选平面图',
    sorry: '暂时未有提供相关平面图，我们正努力制作中',

    popover: '最多选择5项',
    imgloading: '上传中',
    Inline: '列队中',
    imgfaile: '上传失败',
    imgdel: '请删除',
    selectWords: '选择常用词',
    usualWords: '请选择常用词',
    maxSentence: '请最多选择5句，再自行修改',
    maxInSentence: '请最多选择10句，再自行修改',

    setNow: '立即设定',
    setEmailNotice: '刊登楼盘前，必须设定电邮',
    setWordNotice: '刊登楼盘前，必须设定密码',
    keyWords: '内容不符合会员条款',
    keyCon: '确认',
    cant: '无法刊登',
    // post
    stop: '对不起，功能暂时停用',
    start: '请前往会员中心上传您的地产代理证，待确认后功能会重新启用',
    goEdit: '前往会员中心',
    // upscan
    postSuccess: '楼盘已成功刊登，你现在可以关闭此页面',
    centSign: '中原楼市片区',
    // up_pic
    maximumPhotos1: '已选择',
    maximumPhotos2: '张图片 最多可上传20张图片 ',
    maximumPhotos3: '移动图片可调换图片位置，左上角第一张为封面图',
    delPic: '移除图片',
    picLength: '已超过图片上传数量限制',
    picuping: '图片上传中',
    picfailure: '上传失败,请重新上传',
    fileBig: '档案大小必须20MB以下',
    // 标题
    first: '封面',
    toptitle: '刊登楼盘',
    vid_title: "楼盘影片",
    vid_cover: "影片封面",
    edittitle: '更改楼盘资料',
    up_title: '上传图片',
    up_vid: '请输入影片链接',
    up_yfvid: '请输入YouTube或Facebook网站的影片链接',
    paytitle: '立即付款',
    copytitle: '复制楼盘',
    addSuntitle: '续期',
    topclear: '清空',
    prev: '上一步',
    next: '下一步',

    // 楼盘标签
    tag: '标签',
    alsel: "已选",
    ected: '个标签',
    order: '调整标签顺序',
    char: '单位特色',
    mofour: '最多选择4个',
    sce: '景观',
    ren: '装修',
    moone: '最多选择1个',
    mat: '配套',
    mothree: '最多选择3个',
    mosix: '最多选择6个',
    notice: '注：步行往港铁站约',
    sub: '分钟',
    foottime: '步行时间是由系统计算出来的，当步行时间在15分钟内，可选择＂近港铁＂标签',
    bus: '工商专用',
    park: '配套(车位專用) ',
    alselected: '已选标签:',
    showfive: '楼盘列表只会显示前5个标签',
    drag: '按住可拖动标签调整顺序，列表详情页根据顺序显示',

    // step1
    nopic: '没有选择图片',
    continue: '确定要继续?',
    confrimExit: '确定退出',
    goaway: '你所输入的楼盘內容将不会被存储',
    confirm: '确定',
    confirm1: '确认',
    soonPost: '立即刊登',
    yezhuTit: '业主免费放盘',
    yezhuCon: 'House730现免费供业主刊登楼盘，业主只需填妥刊登放盘资料并上传地址证明，就可以免费放盘!',
    yezhuAdd:'放盘后,House730会先作出审批再作上架',
    cancel: '取消',
    Clearcontent: '确定清除已输入内容？ ',
    clear: '清除',
    addPic: '楼盘图片',
    addVid: '楼盘视频',
    addTips: '加入图片可令你的楼盘更吸引',
    write: '请填写',
    selsctSource: '选择盘源',
    agent: '盘源',
    landlord: '业主',
    titOne: '楼盘及联络资料',
    source: '盘源',
    contactNameChi: '联络人名称',
    contactNameEng: '联络人英文名称',
    email: '电邮地址',
    tel: '联络电话',
    telShow: '显示电话',
    showPhone: '显示电话号码',
    dontShow: '不显示我的电话',
    tool: ['我有WhatsApp', '我有WeChat'],
    require1: {
      source: '请选择盘源',
      Cname: '请输入联络人名称',
      email: '请输入电邮地址',
      emailFormat: '电邮地址错误',
      tel: '请输入联络电话',
      telFormat: '格式错误 - 联络电话',
      telShow: '请选择是否显示电话'
    },
    // step2
    agencyInformation: '地产代理资料',
    agentCard: '地产代理证',
    // agentCardTime: '地产代理证到期日',
    agentCardTime: '地产牌照届满日期',
    companyName: '代理公司名称',
    companyShow: '代理公司资料及个人地产代理牌照',
    companyNameEng: '代理公司名称英文',
    companyPhone: '代理公司电话',
    chinaMobile: '国内联络电话',
    companyAddress: '代理公司地址',
    companyLicense: '公司地产代理牌照',
    personalLicense: '个人地产代理牌照',
    not86: '(无需填写86)',
    show: '显示',
    notShow: '不显示',
    upload: '上传',
    require2: {
      companyName: '请填写代理公司名称',
      companyShow: '请选择代理公司资料及个人地产代理牌照',
      companyPhone: '请填写代理公司电话',
      companyLicense: '请填写公司地产代理牌照',
      personalLicense: '请填写个人代理牌照',
      companyTelFormat: '格式错误 - 代理公司电话',
      TelFormat: '格式错误 - 国内联络电话',
      agentCardPath: '请上传地产代理证',
      // agentCardExpireTime:'请选择地产代理证到期日',
      agentCardExpireTime:'请选择地产牌照届满日期',
    },
    // step3
    propertyTypeAndAddress: '放盘分类及地址',
    housenum: '期数',
    housenum1: '期数',
    buildNum: '座数',
    propertyType: '楼盘类型',
    propertyTags: '楼盘标签',
    onlyCategories: '最多选择两个分类',
    towerAndUnit: '座数及单位',
    propertyAddress: '物业地址',
    require3: {
      propertyType: '楼盘类型必须选择',
      estateOrBuildingName: '请输入屋苑或大廈名称'
    },
    // searchBuilding
    estateOrBuildingName: '屋苑或大厦名称',
    manuallyEnterBuilding: '如你找不到屋苑名或大厦名称，你亦可手动输入屋苑名称。 ',
    inputEstateOrBuildingName: '手动输入地区屋苑',
    region: '地区',
    district: '楼市片区',
    houseChiName: '屋苑或大厦名称(中文）',
    houseEngName: '屋苑或大厦名称(英文）',
    search: '搜寻：屋苑或大厦名称',
    checked: '手动输入的屋苑或大厦,将由House730管理员审核',
    requireAddress: {
      region: '请选择屋苑所在地区',
      houseChiName: '請輸入屋苑或大厦名称'
    },
    // step4
    rentTime: '可随时起租',
    SaleFrom: '绿/白表',
    areaPoint: '实用面积或建筑面积至少填写一项',
    MsaleForm:'未补或已补地价至少填写一项',
    propertyprice: '楼盘价格及面积',
    sale: '放售',
    rent: '放租',
    sellPrice: '放售价',
    sellPriceUnit: '万元',
    rentalPrice: '放租价',
    renPriceUnit: '元',
    startDate: '起租日',
    revRatio:'选择后会在House730显示减价比率,最大比率为30%',
    evaVau:'减价盘',
    areaUncheck:'面积未核实',
    mesUncheck:'如面积未核实,须注明未核实并会在',
    houseWebsite:'House730网页上显示。',
    remove: '移除',
    withCarParkL: '连车位',
    buildArea: '建筑面积(呎）',
    useArea: '实用面积(呎）',
    reviewArea: '面积资料未审核',
    unPaid:'未补地价',
    alPaid:'已补地价',
    yibu:'已补',
    weibu:'未补',
    mrentPrice: '每月租金(元）',
    mrebtData: '起租日',
    otherOps: ' 其他选项',
    rentOrSale: '只可选放售或放租其中一項',
    require4: {
      rent: '请填写每月租金',
      Area: '请填写建筑面积或实用面积',
      sale: '请输入放售价',
      SaleForm: '请选择绿表价或白表价',
      MsaleForm:'未补或已补地价至少填写一项',
      salePrice: '格式错误 - 放售价',
      rentPrice: '格式错误 - 每月租金',
      buildArea: '格式错误 - 建筑面积',
      saleArea: '格式错误 - 实用面积'
    },
    // step5
    bedrooms: '房间数目',
    propertyInfo: '楼盘资料',
    propertyNumber: '物业编号',
    eaaRequired: 'EAA要求提供',
    adsTitleChi: '放盘标题(中文)',
    adsTitleEng: '放盘标题(英文)',
    titleLimitC: '最多30字',
    titleLimitE: '最多50字',
    propertyDescription: '楼盘介绍',
    propertyDescriptionChi: '楼盘介绍(中文)',
    propertyDescriptionEng: '楼盘介绍(英文)',
    descriptionLimitC: '最多300字',
    descriptionLimitE: '最多600字',
    propertyDetails: '楼盘详情',
    height: '高/中/低层',
    height1: '楼层',
    noOfRooms: '房间数目',
    ToiletRooms: '洗手间数目',
    age: '屋苑楼龄(年)',
    monthlyManagementFee: '每月管理费(元)',
    require5: {
      adsTitleChi: '请填写放盘标题(中文)',
      adspropertyNumber: '请输入物业编号',
      propertyDescriptionChi: '请填写楼盘介绍(中文)',
      age: '格式错误 - 屋苑楼龄',
      monthlyManagementFee: '格式错误 - 每月管理费',
      adspropertyNumErr: '物业编号必须为英文字母、数字或符号'
    },
    // step6
    topOne: '刊登精选盘必须上传至少一张图片',
    tip: '提示',
    maxRenewal: '已达续期上限\n在有效期内楼盘最多续期1次',
    tipStatus: '订单状态不正确，请重试!',
    ri: '日',
    agreeClause: '必须同意放盘条款才可继续',
    paywayRequ: '付款方式及放盘方式为必选',
    addRequ: '请提交楼盘验证文件',
    yezhuRequ: '请上传免费放盘验证文件',
    noChance: '操作失败',
    GoldCoin: '金币',
    Generallisting1: '一般放盘',
    Generallisting2: '有较高曝光机会',
    Dpayway: [{ name: 'PayPal', value: '1' }, { name: 'House730金币', value: '2' }, { name: '银行转账', value: '3' }],
    NoCoinPayway: [{ name: 'PayPal', value: '1' }, { name: '银行转账', value: '3' }],
    span: '售盘为期',
    zpan: '租盘为期',
    szpan: '售盘/租盘为期',
    verif: '楼盘验证',
    verifRemark: '楼盘详情显示为<span style="color:#ED1818">「已验证」</span>,加强买家/租户信心',
    adClass: '放盘方式',
    updateSuccess: '楼盘资料已更新',
    payway: '付款方式',
    listingNorl: '标准盘',
    listingGolt: '精选盘',
    listingStar: "星级盘",
    Conditions: ['同意', '放盘条款'],
    addressProof: '楼盘验证文件',
    upYezhufile: '上传免费放盘验证文件',
    imgTit:'(只接受JPEG, JPG及PNG图片格式)',
    submit: '提交放盘',
    needMoeny: '金额',
    subEdit: '提交更改',
    confrimType: '确定放盘类型',
    confrimCate: '放盘方式',
    confrimMoeny: '付款总额',
    confrimtxt: '请按确定提交放盘及付款',
    previous: '上一步',
    noGold: '金币不足', //屋币不足提示
    noGoldText: '请先增值或改用其他方式付款',
    addGold: '增值',
    // address
    addTit: '地址证明',
    addYezhu: '上传免费放盘验证文件',
    up: '最多只能上传3张图片',
    uptitle: '上传图片(最多3张）',
    address1: '请上传楼盘的委託放盘证明、确实地址、业权证明及其他相关资料，或将相关资料WhatsApp到 5726 6308，我们会在3个工作天内完成审核',
    address2: '如果你是业主，请提供电费单/水费单/差饷',
    address3: '如果你是代理，请提供委託放盘证明及其他相关资料',
    address4: '如审核过程发现证明文件与楼盘资料不符，楼盘将被下架并不作另行通知。',
    address5: '请提供附有楼盘确实地址的证明，建议上传以下其中一类型文件，包括：',
    address6: '- 电费单',
    address7: '- 水费单',
    address8: '- 差餉',
    address9: ' - 管理费单',
    address10: '- 车位图片 *只适用于刊登车位',
    address11: '你的楼盘将由House730审批上架。',
    address12: '一般在1~3个工作天内完成,我们会发电邮通知你。',
    address13: '如审核过程发现证明文件与楼盘资料不符,楼盘将不会被上架。',
    address14: '如有任何问题,欢迎与我们联络 WhatsApp：+852 5726 6308/ Email：general@house730.com(标题请注明“楼盘审核”)/Tel：+852 3619 3200',
    thanks: '付款成功',
    submitSuc:'提交成功',
    payDone: '你的楼盘已刊登',
    payDownStar: '星级盘参考排名将于稍后更新',
    payAdd: '你的升级或续期已成功付款',
    fileError: '只支持png、jpg、jpeg格式的图片',
    fileExist: '存在重复文件，已过滤',
    // 楼盘校验
    require: {
      phase: '请选择期数',
      buildName: '请选择座数',
      subcgory:'请选择楼盘详细类别',
      buildFloorRequire: '请选择楼层',
      unitFloorRqueire: '星级盘必须选择高/中/低层',
      toiletNumberRqueire: '星级盘必须选择洗手间数目',
      unitFloorRqueire1: '请选择高/中/低层',
      plamtImage: '請選擇平面圖',
      areaTip: '实用面积必须细过或等于建筑面积',
      source: '请选择盘源',
      Cname: '请输入联络人名称',
      email: '请输入电邮地址',
      emailFormat: '电邮地址错误',
      tel: '请输入联络电话',
      telFormat: '格式错误 - 联络电话',
      telShow: '请选择是否显示电话',
      companyName: '请填写代理公司名称',
      companyShow: '请选择代理公司资料及个人地产代理牌照',
      companyPhone: '请填写代理公司电话',
      companyLicense: '请填写公司地产代理牌照',
      personalLicense: '请填写个人代理牌照',
      companyTelFormat: '格式错误 - 代理公司电话',
      TelFormat: '格式错误 - 国内联络电话',
      agentCardPath: '请上传地产代理证',
      agentCardExpireTime:'请选择地产代理证到期日',
      // 楼盘信息
      propertyType: '请选择楼盘类型',
      estateOrBuildingName: '请输入屋苑或大厦名称',
      rent: '请填写每月租金',
      Area: '请填写建筑面积或实用面积',
      sale: '请输入放售价',
      SaleForm: '请选择绿表价或白表价',
      MsaleForm:'未补或已补地价至少填写一项',
      salePrice: '格式错误 - 放售价',
      rentPrice: '格式错误 - 每月租金',
      buildArea: '格式错误 - 建筑面积',
      saleArea: '格式错误 - 实用面积',
      adsTitleChi: '请填写放盘标题(中文)',
      adspropertyNumber: '请输入物业编号',
      propertyDescriptionChi: '请填写楼盘介绍(中文)',
      age: '格式错误 - 屋苑楼龄',
      monthlyManagementFee: '格式错误 - 每月管理费',
      adspropertyNumErr: '物业编号必须为英文字母、数字或符号',
      starHeight: '星级盘必须选择单位楼层',
      startRequir: '星级盘必须选择',
      starRoom: '星级盘必须选择房间数目',
      starTitCn: '星级盘中文标题必须不少于8个字',
      starImage: `星級盤必須上載3張圖片`,
      nomalImage: `刊登标准盘必须上载至少一张图片`
    },
    imageTips: `标准盘 - 上载至少1张图片、星级盘 - 上载至少3张图片`,
    saleTitle: '售盘',
    rentTitle: "租盘",
    chooseType: '请选择放盘方式',
    startTip: '星级盘必须选择单位楼层、房间数目和洗手间数目',
    quitChoose: '取消选择',
    propertyDetail: "放盘资料",
    concantDetail: '联络资料',
    Coin: 'House730金币',
    transferFake: '(会在下一个工作天内处理完成)',
    transfer: '银行转帐',
    visa: '适用于信用卡, Visa/MasterCard结账',
    clearAll: '取消所有选项',
    pleSelect: '请选择',
    pleInput: '请输入',
    saleO:'目前售价为',
    saleOt:'亿元,',
    saleOth:'确定',
    saleOf:'更改',
    saleOfi:'萬元,',
    saleOs:'请确定或更改你的售价',
    saleOse:'你所输入的售价与原本的有很大的差距',
    saleOe:'请确认售价是否正确',
    saleOn:'知道了',
    propertyNoPleSelect: 'EAA要求提供请输入',
    photoPosition: '图片位置',
    moveDel: '拖动到此处移除',
    photoIntro: '第一张为封面，移动图片可调换图片位置',
    photoIntro2: '点击图片可进行预览，加入图片位置及描述',
    notSave: '你尚未储存',
    saveTip: '若确认舍弃，系统将不会储存图片位置及描述',
    photoMax: '请输入图片描述（最多50个字）',
    chucun: '储存',
    alipayText: '只适用于已注册的Alipay HK用戶',
    wePayText: '只适用于已注册的WeChat Pay HK用戶',
    diqu: '地区选择', isHideCompanyInfo: {
      dictionaryNameWithCulture: '代理公司资料及个人地产代理牌照',
      dictionaryContent: '如拣选不显示，在楼盘详情中，只会显示代理联络电话和代理牌照，不会显示公司名称、地址、公司电话，公司牌照',
      itemName: "isHideCompanyInfo",
      children: [{
        dictionaryNameWithCulture: '显示',
        dictionaryValue: false,
        id: 0,
      }, {
        dictionaryNameWithCulture: '不显示',
        dictionaryValue: true,
        id: 0,
      }]
    },
    isShowTel: {
      dictionaryNameWithCulture: '显示电话',
      itemName: "isShowTel",
      children: [
        {
          dictionaryNameWithCulture: '显示电话',
          dictionaryValue: true,
          children: [
            {
              dictionaryNameWithCulture: '我有WhatsApp',
              dictionaryValue: 1,
              id: 0,
              attr: 'isShowWhatsApp'
            }
            // {
            //   dictionaryNameWithCulture: '我有WeChat',
            //   dictionaryValue: 2,
            //   id: 1,
            //   attr: 'isShowWeChat'
            // }
          ]
        }, {
          dictionaryNameWithCulture: '不显示我的电话',
          dictionaryValue: false
        }
      ]
    }
  },
  'en-us': {
    remark: 'Ranking of Listings',
    PropertyValuation: 'Property Valuation',
    PropertyValuationTips: 'After activation, users can use the property valuation function on the property details page (if have)The Instant Property Valuation is provided by third party entrusted by Bank of China (Hong Kong) Limited and is for reference only.',
    unitFloorTips: 'According to the total number of floors divided by 3, divided into high/middle/low floors',
    consultingText1: 'If you have any question, please call 3619 3200',
    consultingText2: 'Mon - Fri, 9:00AM - 6:00PM',
    addressTips: 'The entered content will be displayed on the property details page, please do not enter the complete address',
    noRenewalText: 'Due to the incomplete property information, the property cannot be renewed, and the information must be filled in first',
    parNowText: 'Due to incomplete property information, payment cannot be made, and the information must be filled in first',
    propertyInformation2: 'Property information display: Your property information will be displayed on House730 as such',
    propertyInformation3: 'The property information is absolutely confidential, and the floors will be displayed as upper/middle/lower floors.',
    PropertySelected: 'Property Type must be selected ',
    selectText: 'Select',
    estateAddress: 'Street Number',
    estateAddressPlaceHolder: 'E.g. 1 Tin Wu Road',
    estateYear: 'Years Built',
    cancelEditTxt: 'If you have made changes on the page, they will be lost when leaving the current page',
    cancelEdit: 'Cancel',
    yes: 'Yes',
    no: 'No',
    submitHouseInfo: 'Confirm to submit your listing?',
    propertyVerificationtxt1: 'Real estate verification failure prompt',
    propertyVerificationtxt2: 'Because you have modified below information, the estate verification will be invalid, and we need to review it again',
    propertyVerificationtxt3: 'Want to resubmit the estate verification?',
    creditCard:'Credit Card',
    cre: 'Credit Card (VISA, Mastercard)',
    tipsKeyWord: 'The lease term of the serviced apartment is at least one month, but within one year; the owner provides a complete set of home equipment including decoration, kitchen and furniture, as well as central management including maintenance and service.',
    tipsKeyWord_GongJv: 'Co-living usually requires a minimum rental period of one month or longer. Landlords provide furnished living spaces and shared common areas like the kitchen, living room, and bathroom. Each tenant has their own private bedroom while sharing the common areas.',
    FreeY: 'Free',
    //平面图
    choosepropertyPlat: 'Floor Plan',
    propertyPlat: 'Floor Plan Selection',
    chooseImg: 'Selected ',
    zhang: ' images',
    setArea: 'Set Area',
    unit: 'Unit: Sq. ft.',
    smallestArea: 'Lowest SFA',
    largestArea: 'Highest SFA',
    //  errorSaleableArea: '實用面積區間錯誤',
    phase: 'Phase',
    block: 'Block',
    floor: 'Floor',
    unitD: 'Unit',
    saleableArea: 'Saleable Area',
    eachType: 'Each Type of Floor Plan Can Only Be Selected Once',
    unitFloorPlan: 'Unit Floor Plan',
    floorPlan: 'Floor Plan',
    highestSFA: 'Highest SFA',
    lowestSFA: 'Lowest SFA',
    house730: '@provided by House730',
    selectedFloorplan: 'Selected Floorplan',
    sorry: 'Sorry, the requested floor plan is not available. We are working on it.',

    popover: '5 sentence at most',
    selectWords: 'Select usual words',
    imgloading: 'Uploading',
    Inline: 'In line',
    imgfaile: 'Upload failed',
    imgdel: 'Please delete',
    usualWords: 'Please select usual words',
    maxSentence: '5 sentence at most, you may edit them after selected.',
    maxInSentence: '10 sentence at most, you may edit them after selected.',

    setNow: 'Edit ',
    setEmailNotice: 'You must add your email before listing a property',
    setWordNotice: 'You must add your password before listing a property',
    keyWords: 'Content does not meet',
    keyWords2: 'Membership T&C ',
    cant: 'Cannot be published',
    keyCon: 'OK',
    // post
    stop: 'Sorry, function temporary suspended',
    start: 'Please go to Member Centre and upload your Estate Agent card, function will be resumed after confirmation',
    goEdit: 'Go to Member Centre',
    // upscan
    postSuccess: 'The property has been successfully published, you can close this page now',
    centSign: 'Centaline Housing Market Area',
    // 标题
    first: 'Cover',
    toptitle: 'Property Listing',
    vid_title: "Property Video",
    vid_cover: "Video Cover Photo",
    edittitle: 'Edit',
    copytitle: 'Copy property',
    up_title: 'Upload Photo',
    up_vid: "Please enter the video link",
    up_yfvid: 'Please enter the video link of YouTube/Facebook',
    paytitle: 'Proceed Payment',
    addSuntitle: 'Re-new',
    topclear: 'Clear',
    prev: 'Back',
    next: 'Next',
    // 楼盘标签
    tag: 'Tags',
    alsel: "Selected ",
    ected: 'Tags',
    order: 'Adjust tag order',
    char: 'Features',
    mofour: 'Max. Select 4 Options',
    sce: 'View',
    ren: 'Decoration',
    moone: 'Max. Select 1 Options',
    mat: 'Facilities',
    mothree: 'Max. Select 3 Options',
    mosix: 'Max. Select 6 Options',
    notice: 'Note: Walk to the MTR station for about',
    sub: 'minutes',
    foottime: 'The walking time is calculated by the system. When the walking time is within 15 minutes, you can select the "Near MTR" tab',
    bus: 'Offices Use',
    park: 'Facilities (Car Park) ',
    alselected: 'Selected Search Tags:',
    showfive: 'Only the first 5 tags will be displayed in the property list',
    drag: 'Press and hold the draggable tag to adjust the order. It will be displayed in the listing and details page according to the order',

    // step1
    nopic: 'No Photo Selected',
    continue: 'Confirm to Continue?',
    confrimExit: 'Quit?',
    goaway: 'The content of property you input will not be saved',
    confirm: 'OK',
    confirm1: 'OK',
    soonPost:'Start to Post',
    yezhuTit:'Free listing for Landlord',
    yezhuCon:'House730 is now providing free property listing service for landlord, you just need to fill in the property listing information and upload the proof of actual address, then no fee will be charged!',
    yezhuAdd:'Your property listing will be reviewed by House730 before listing.',
    cancel: 'Cancel',
    Clearcontent: 'Clear Content?',
    clear: 'clear',
    addPic: 'Photos',
    addVid: 'Videos',
    addTips: 'Adding photo will make your listing property more attractive',
    write: 'Please fill in',
    selsctSource: 'Source',
    landlord: 'owner',
    titOne: 'Property & Contact Information',
    source: 'source',
    agent: 'Source',
    contactNameChi: 'Contact Name',
    contactNameEng: 'Name (Eng)',
    email: 'Email',
    tel: 'Phone No.',
    telShow: "Show/Don't Show Phone No.",
    showPhone: 'Show my mobile',
    dontShow: "Don't show my mobile",
    tool: ['I have WhatsApp', 'I have WeChat'],
    require1: {
      source: 'Please select Source',
      Cname: 'Please enter Contact Name',
      email: 'Please enter Email Address',
      emailFormat: 'Email Address is invalid',
      tel: 'Please enter Contact Phone No.',
      telFormat: 'Invalid format - Phone No.',
      telShow: "Please select Show/Don't Show Phone No."
    },
    // up_pic
    maximumPhotos1: 'Selected ',
    maximumPhotos2: ' photos, max. upload 20 photos.',
    maximumPhotos3: 'Tapping on the photo, drag and drop to re-order. The 1st photo will be used as cover photo',
    delPic: 'Remove',
    picLength: 'Exceed photo upload limit',
    picuping: 'Picture uploading',
    picfailure: 'Upload failed, please try agin',
    fileBig: 'File size must be less than 20MB',
    // step2
    agentCard: 'Estate Agent Card',
    agentCardTime: 'EAA License Expiry Date',
    agencyInformation: 'Property Agent Information',
    companyName: 'Company Name(Chi)',
    companyShow: 'Company Info and Personal License',
    companyNameEng: 'Company Name (Eng)',
    companyPhone: 'Company phone no.',
    chinaMobile: 'Contact no. for China',
    companyAddress: 'Company address',
    companyLicense: 'Company License',
    personalLicense: 'Personal License',
    not86: '(Exclude 86)',
    show: 'Show',
    notShow: "Don't show",
    upload: 'Upload',
    require2: {
      companyName: 'Please fill in Company Name',
      companyShow: 'Please select Company Info and Personal License',
      companyPhone: 'Please fill in Company Phone No.',
      companyLicense: 'Please provide Company License',
      personalLicense: 'Please provide Personal License',
      companyTelFormat: 'Invalid format - Company Phone No.',
      TelFormat: 'Invalid format - Contact no. for China',
      agentCardPath: 'Please upload Estate Agent Card',
      agentCardExpireTime:'Please select EAA License Expiry Date',
    },
    // step3
    propertyTypeAndAddress: 'Property Type and Address',
    housenum: 'Phase',
    housenum1: 'Phase',
    buildNum: 'Block',
    propertyType: 'Property Type',
    propertyTags: 'Property Tags',
    onlyCategories: 'Select 2 Property Type Only',
    towerAndUnit: 'Block and Unit',
    propertyAddress: 'Address',
    require3: {
      propertyType: 'Property Type must be selected',
      estateOrBuildingName: 'Please provide Estate or Building name'
    },
    // addressCheck
    estateOrBuildingName: 'Estate or Building name',
    manuallyEnterBuilding: 'If you cannot find the estate or building name, you may input manually',
    inputEstateOrBuildingName: 'Manual input Estate or Building name',
    region: 'District',
    district: 'Housing Market Area',
    houseChiName: 'Estate or Building name (Chi)',
    houseEngName: 'Estate or Building name (Eng)',
    search: 'Search：Estate or Building',
    checked: 'Manual input estate or building name will be checked by House730 administrator',
    requireAddress: {
      region: 'Please select District',
      houseChiName: 'Please provide Estate or Building name'
    },

    // step4
    rentTime: 'Immediately Available',
    areaPoint: 'Fill in at least one of the available area or the building area',
    MsaleForm:'Fill in at least one of the Prem.paid or Prem.unpaid',
    propertyprice: 'Property price and area',
    sale: 'For Sale',
    SaleFrom: 'Green/White form',
    rent: 'For Rent',
    sellPrice: 'Selling Price',
    sellPriceUnit: '10K',
    rentalPrice: 'Rental Price',
    renPriceUnit: 'HKD',
    startDate: 'Start Date',
    revRatio:'After selection, the markdown rate will be displayed on House730. The maximum rate is 30%.',
    evaVau:'Markdown',
    areaUncheck:'Area unverified',
    mesUncheck:'If the area is unverified, it should be noted and will be displayed ',
    houseWebsite:'on House730 website',
    remove: 'remove',
    withCarParkL: 'With car park',
    buildArea: 'GFA(sq. ft)',
    useArea: 'SFA (sq. ft)',
    reviewArea: 'Area data not reviewed',
    mrentPrice: 'Rental per Month (HKD)',
    unPaid:' Premium Unpaid',
    alPaid:' Premium Paid',
    yibu:'Prem. paid',
    weibu:'Prem. unpaid',
    mrebtData: 'Rent Start Date',
    otherOps: 'Additional Option',
    rentOrSale: 'Select for sales or for rent only',
    require4: {
      rent: 'Please fill in Rental per Month (HKD)',
      Area: 'Please fill in Gross Area/Saleable Area',
      sale: 'Please fill in Price for Sale',
      SaleForm: 'Please select Green/White form',
      MsaleForm:'Fill in at least one of the Prem.paid or Prem.unpaid',
      salePrice: 'Invalid format - Selling Price',
      rentPrice: 'Invalid format - Rental per month',
      buildArea: 'Invalid format - Gross Area',
      saleArea: 'Invalid format - Saleable Area'
    },
    // step5
    bedrooms: 'Bedrooms',
    propertyInfo: 'Property Details',
    propertyNumber: 'Property ID',
    eaaRequired: 'Requested by EAA',
    adsTitleChi: 'Title (Chi)',
    adsTitleEng: 'Title (Eng)',
    titleLimitC: 'Max. 30 words',
    titleLimitE: 'Max. 50 words',
    propertyDescriptionChi: 'Description (Chi)',
    propertyDescriptionEng: 'Description (Eng)',
    descriptionLimitC: 'Max. 300 words',
    descriptionLimitE: 'Max. 600 words',
    propertyDetails: 'Property Details',
    height: 'Floor Display',
    height1: 'Floor',
    noOfRooms: 'No. of Rooms',
    ToiletRooms: 'No. of Bathrooms',
    age: 'Years Built',
    span: ' (for sale) or ',
    zpan: ' (for rent) ',
    szpan: ' days (for sale or rent) ',
    monthlyManagementFee: 'Management Fee per Month',
    require5: {
      adsTitleChi: 'Please fill in Title (Chi)',
      adspropertyNumber: 'Please fill in Property ID',
      propertyDescriptionChi: 'Please fill in Description (Chi)',
      age: 'Invalid format - Years Built',
      monthlyManagementFee: 'Invalid format - Management Fee per Month',
      adspropertyNumErr: 'Property ID must be alphanumeric characters or symbols'
    },
    listingTypeAndPayment: 'Listing Type and Payment',
    // step6
    topOne: 'Featured Listing requires at least 1 photo',
    tip: 'prompt',
    maxRenewal: 'Limit Reached \n Can only renew 1 times before expired',
    tipStatus: 'Order status is invalid, please try again!',
    ri: 'days',
    agreeClause: 'You must agree Property Listing terms and conditions to continue',
    paywayRequ: 'Payment Method and Listing Type must be seleted',
    addRequ: 'Please submit the proof of property verification',
    yezhuRequ: 'Please upload verification file(s) for free listing',
    noChance: 'operation failed',
    GoldCoin: 'Gold Coin',
    Generallisting1: 'General listing',
    Generallisting2: 'Listing with better exposure',
    Dpayway: [{ name: 'PayPal', value: '1' }, { name: 'House730 Gold Coin', value: '2' }, { name: 'Bank transfer ', value: '3' }],
    NoCoinPayway: [{ name: 'PayPal', value: '1' }, { name: 'Bank transfer ', value: '3' }],
    adClass: 'Listing Method',
    updateSuccess: 'Property information has been updated',
    payway: 'Payment Method',
    listingNorl: 'Standard',
    listingGolt: 'Featured',
    listingStar: "Premium",
    agreeConditions: 'Property Published Regulations and Notices',
    // Conditions: 'Property Published Regulation',
    Conditions: ['I agree to', ' Property Published Regulation'],
    verif: 'Verified Service',
    verifRemark: 'Your property will be highlighted as <span style="color:#ED1818">"verified"</span>  to increase confidence of buyer/ tenant',
    addressProof: 'Verification Document',
    upYezhufile: 'Upload Verification Files for Free Listing',
    imgTit: '(Only accept JPEG, JPG and PNG image formats)',
    submit: 'Submit',
    needMoeny: 'Amount',
    subEdit: 'Submit',
    confrimType: 'Confirm Listing Method',
    confrimCate: 'Listing Method',
    confrimMoeny: 'Amount',
    confrimtxt: 'Click OK to publish your property and proceed payment',
    previous: 'Back',
    thanks: 'Payment Successful',
    submitSuc:'Application received',
    noGold: 'Not enough Gold Coins', //屋币不足提示
    noGoldText: 'Please recharge Gold Coin or use other payment method',
    addGold: 'Recharge',
    // address
    addTit: 'Property Verification',
    addYezhu: 'Upload Verification Files for Free Listing',
    up: 'Up to 3 photos can be uploaded at most',
    uptitle: 'Upload Photo (max. 3)',
    address1:
      'Please upload the proof of agent appointment, actual address, property ownership and other relevant information or send it to us via WhatsApp 5726 6308. We will verify within 3 working day.',
    address2: 'If you are landlord, please provide electric bill/water bill/rates and government rent',
    address3: 'If you are property agent, please provide proof of agent appointment or other relevant information',
    address4: 'If we find the proof and property listing information cannot be verified, the property listing will be suspended without further notice.',
    address5: 'Please provide the proof of actual address, we recommend you to upload one of the following:',
    address6: '- Electric Bill',
    address7: '- Water Bill ',
    address8: '- Rates and Government Rent',
    address9: ' - Property management fee bill',
    address10: '- Car Park Image *Only applicable to Car Park Listing',
    address11: 'Your property listing is being reviewed by House730 within 1-3 working days.',
    address12: 'Email notification will be sent once the process is done.',
    address13: 'If the verification process finds that the supporting documents do not match the listing information, the listing will not be listed.',
    address14: 'If you have any questions, please feel free to contact us by WhatsApp: +852 5726 6308 or Email: general@house730.com (please indicate "property review" in the title)/Tel: +852 3619 3200.',
    Thanks: 'thank you',
    payDone: 'Your property is now published',
    payDownStar: 'Premium Listing Ref. Ranking will be updated soon',
    payAdd: 'Your upgrade or renewal has been successfully paid',
    fileError: 'Only supports images in png, jpg, jpeg format',
    fileExist: 'Duplicate files exist, filtered',
    // 楼盘校验
    require: {
      phase: 'Please select Phase',
      subcgory:'Please select the property details category',
      buildName: 'Please select Block',
      MsaleForm:'Fill in at least one of the Prem.paid or Prem.unpaid',
      buildFloorRequire: 'Please select Floor',
      unitFloorRqueire: 'Premium Listing must provide Floor Display',
      toiletNumberRqueire: 'Premium Listing must provide No. of Bathrooms',
      unitFloorRqueire1: 'Please select upper/middle/lower floors',
      plamtImage: '請選擇平面圖',
      areaTip: 'Saleable Area must be less than or equal to Gross Area',
      source: 'Please select Source',
      Cname: 'Please enter Contact Name',
      email: 'Please enter Email Address',
      emailFormat: 'Email Address is invalid',
      tel: 'Please enter Contact Phone No.',
      telFormat: 'Invalid format - Phone No.',
      telShow: "Please select Show/Don't Show Phone No.",
      companyName: 'Please fill in Company Name',
      companyShow: 'Please select Company Info and Personal License',
      companyPhone: 'Please fill in Company Phone No.',
      companyLicense: 'Please provide Company License',
      personalLicense: 'Please provide Personal License',
      companyTelFormat: 'Invalid format - Company Phone No.',
      TelFormat: 'Invalid format - Contact no. for China',
      agentCardPath: 'Please upload Estate Agent Card',
      agentCardExpireTime:'Please select EAA License Expiry Date',
      // 楼盘信息
      propertyType: 'Property Type must be selected',
      estateOrBuildingName: 'Please provide Estate or Building name',
      rent: 'Please fill in Rental per Month (HKD)',
      Area: 'Please fill in Gross Area/Saleable Area',
      sale: 'Please fill in Price for Sale',
      // SaleForm: '请选择绿表价或白表价',
      // salePrice: '格式错误 - 放售价',
      // rentPrice: '格式错误 - 每月租金',
      // buildArea: '格式错误 - 建筑面积',
      // saleArea: '格式错误 - 实用面积',
      adsTitleChi: 'Please fill in Title (Chi)',
      adspropertyNumber: 'Please fill in Property ID',
      propertyDescriptionChi: 'Please fill in Description (Chi)',
      adspropertyNumErr: 'Property ID must be alphanumeric characters or symbols',
      starHeight: 'Premium Listing must provide Floor',
      startRequir: 'Premium Listing must provide',
      starRoom: 'Premium Listing must provide No. of Rooms',
      starTitCn: 'Premium Listing requires Title (Chi) with at least 8 words',
      starImage: 'Premium Listing - Upload at least 3 photos',
      nomalImage: 'Standard Listing - Upload at least 1 photo'
    },
    imageTips: `Standard Listing - Upload at least 1 photo
    Premium Listing - Upload at least 3 photos`,
    startTip: 'Premium Listing must provide No. of Bathrooms;  Premium Listing must provide Floor Display ',
    quitChoose: 'Cancel',
    propertyDetail: "Property Details",
    concantDetail: 'Contact Information',
    Coin: 'House730 Gold Coin',
    transferFake: '(will be handled on/before next working day)',
    transfer: 'Bank transfer',
    saleTitle: 'Sale',
    rentTitle: "Rent",
    chooseType: 'Please select for',
    visa: 'Pay by credit card, Visa/Mastercard',
    clearAll: 'Clear',
    pleSelect: 'Please select',
    pleInput: 'Please enter',
    saleO:'The current price is ',
    saleOt:' billion,',
    saleOm:' million,',
    saleOth:'Confirm',
    saleOf:'Edit',
    saleOs:'please confirm or change your price',
    saleOse:'There is a big difference between the sale price you input and the original.',
    saleOe:'Please confirm if the price is correct',
    saleOn:'OK',
    propertyNoPleSelect: 'Requested by EAA',
    photoPosition: 'Photo Position',
    moveDel: 'Drag and drop photo here to delete',
    photoIntro: 'The first photo will be cover photo',
    photoIntro2: 'Click to preview, add photo position and description',
    notSave: "You haven't saved",
    saveTip: 'If you confirm to leave, photo position and description will be cleard',
    photoMax: 'Please enter photo description (max. 50 words)',
    chucun: 'Save',
    diqu: 'District',
    alipayText: 'only applicable to AlipayHK registered users',
    wePayText: 'only applicable to WeChat Pay HK registered users',
    isHideCompanyInfo: {
      dictionaryNameWithCulture: 'Company Info and Personal License',
      itemName: "isHideCompanyInfo",
      dictionaryContent: `If selected "Don't Show", only your phone no. and license no. will be shown on the property details page`,
      children: [{
        dictionaryNameWithCulture: 'Show',
        dictionaryValue: false,
        id: 0,
      }, {
        dictionaryNameWithCulture: "Don't show",
        dictionaryValue: true,
        id: 0,
      }]
    },
    isShowTel: {
      dictionaryNameWithCulture: "Show/Don't Show Phone No.",
      itemName: "isShowTel",
      children: [
        {
          dictionaryNameWithCulture: 'Show my mobile',
          dictionaryValue: true,
          children: [
            {
              dictionaryNameWithCulture: "I have WhatsApp",
              dictionaryValue: 1,
              id: 0,
              attr: 'isShowWhatsApp'
            }
            // {
            //   dictionaryNameWithCulture: 'I have WeChat',
            //   dictionaryValue: 2,
            //   id: 1,
            //   attr: 'isShowWeChat'
            // }
          ]
        }, {
          dictionaryNameWithCulture: "Don't show my mobile",
          dictionaryValue: false
        }
      ]
    },
  }
};
export default language[type];
